import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useUpdateImportedStatusMutation(onDone = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation excludeCrmStatus($statuses: [String]!) {
        excludeCrmStatus(statuses: $statuses) {
          crmStatus
        }
      }
    `;

    const resolver = (resp) => {
      return resp;
    };

    return { query, resolver };
  }, []);

  const [mutate, { loading }] = useMutationWithToaster(mutationFactory, {
    onDone: useCallback(onDone, []),
  });

  return {
    update: (excludeCrmStatus) => {
      mutate(
        { statuses: excludeCrmStatus },
        {
          successMsg: "The Imported Status has been successfully updated",
          defaultErrorMsg:
            "Failed to update the Imported Status, please try again or contact support for assistance.",
        }
      );
    },
    loading: loading,
  };
}

export default useUpdateImportedStatusMutation;
